import { render, staticRenderFns } from "./FormProjectDocument.vue?vue&type=template&id=0b48e6d0&scoped=true"
import script from "./FormProjectDocument.vue?vue&type=script&lang=js"
export * from "./FormProjectDocument.vue?vue&type=script&lang=js"
import style0 from "./FormProjectDocument.vue?vue&type=style&index=0&id=0b48e6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48e6d0",
  null
  
)

export default component.exports